import WidgetInfo, { renderPermissionStatus } from './WidgetInfo';

export default WidgetInfo;
export {
  renderPermissionStatus
};
